import { StepConfig } from '../../../../shared/components/StepperFormModal/types';
import { ClientFormStep } from '../../constants';
import ClientInfoStep from './ClientInfoStep';
import SubscriptionStep from './SubscriptionStep';
import PaymentStep from './PaymentStep';
import SummaryStep from './SummaryStep';

// Module level so the step components keep stable identities.
export const CLIENT_FORM_STEPS: readonly StepConfig<ClientFormStep>[] = [
  { id: ClientFormStep.CLIENT, label: 'Client', Component: ClientInfoStep, hideBack: true },
  { id: ClientFormStep.SUBSCRIPTION, label: 'Subscription', Component: SubscriptionStep },
  { id: ClientFormStep.PAYMENT, label: 'Payment', Component: PaymentStep },
  { id: ClientFormStep.SUMMARY, label: 'Summary', Component: SummaryStep },
];
